import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { persons } from 'models/persons'; // Importing persons model

/**
 * AgeView class extends JetView to create a chart view.
 */
export default class AgeView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text

        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Income from various age groups'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view
                    type: 'scatter', // Scatter chart type
                    localId: 'chart', // Local ID for referencing the chart
                    padding: {
                        // Padding for the chart
                        top: 10,
                        left: 50,
                        bottom: 40,
                    },
                    /**
                     * Calculates the x-axis value based on the age derived from birthday.
                     * @param {Object} obj - Data object containing birthday.
                     * @returns {number} Age calculated from birthday.
                     */
                    xValue: (obj) => {
                        return (
                            new Date().getFullYear() - // Current year
                            new Date(obj.birthday).getFullYear() // Year from birthday
                        );
                    },
                    value: '#money#', // Data field for y-axis value
                    item: {
                        // Configuration for chart items
                        borderColor: '#fff', // Item border color
                        color: '#8664C6', // Item fill color
                        shadow: false, // Shadow effect
                        radius: 7, // Item radius
                        type: 'd', // Item type
                    },
                    xAxis: {
                        // Configuration for x-axis
                        start: 22, // Starting value
                        end: 44, // Ending value
                        step: 4, // Step size
                        lines: false, // Disable grid lines
                        color: '#EDEFF0', // Axis color
                    },
                    yAxis: {
                        // Configuration for y-axis
                        start: 0, // Starting value
                        end: 1500, // Ending value
                        step: 500, // Step size
                        color: '#fff', // Axis color
                        lineColor: '#EDEFF0', // Line color
                    },
                    tooltip: {
                        // Tooltip configuration
                        template: '<b>#fname# #lname#</b><br>$#money#', // Tooltip template
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and synchronizes the chart with the persons model.
     */
    init() {
        this.$$('chart').sync(persons); // Sync chart data with persons model
    }
}

// FILE DOCUMENTED
